import "@/index.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Inventory from "@/pages/Inventory";
import Intake from "@/pages/Intake";
import VehicleDetail from "@/pages/VehicleDetail";
import Cashier from "@/pages/Cashier";
import Audit from "@/pages/Audit";
import Mediators from "@/pages/Mediators";
import Reports from "@/pages/Reports";

function Protected({ children, ownerOnly }) {
  const { user, loading, isOwner } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500 font-semibold">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (ownerOnly && !isOwner) return <Navigate to="/" replace />;
  return children;
}

function App() {
  // Global fix: prevent mouse-wheel from changing number inputs.
  useEffect(() => {
    const onWheel = (e) => {
      const el = document.activeElement;
      if (el && el.tagName === "INPUT" && el.type === "number" && el === e.target) {
        el.blur();
      }
    };
    document.addEventListener("wheel", onWheel, { passive: true });
    return () => document.removeEventListener("wheel", onWheel);
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <Protected>
                <AppLayout />
              </Protected>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="inventory" element={<Inventory />} />
            <Route path="intake" element={<Intake />} />
            <Route path="vehicle/:id" element={<VehicleDetail />} />
            <Route path="cashier" element={<Cashier />} />
            <Route path="mediators" element={<Mediators />} />
            <Route path="reports" element={<Reports />} />
            <Route
              path="audit"
              element={
                <Protected ownerOnly>
                  <Audit />
                </Protected>
              }
            />
          </Route>
        </Routes>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
